
import React from 'react';
import { connect } from 'react-redux';
import InfoModal from '../info-modal/InfoModal';
import { useTranslation } from 'react-i18next';
import { ActionTypes } from '../../actions/action-types';

const LoginSnackbar = ({ error, clearAuthenticationError }) => {
  const { t } = useTranslation();
  
  const getMessage = () => {
    if (error === null) {
      return '';
    }
    if (error.includes('The following fields contained Validation errors')) {
      return t('login.errors.GENERAL');
    }
    return t(`login.errors.${error}`);
  };
  
  const message = getMessage();

  const handleClose = () => {
    if (clearAuthenticationError) {
      clearAuthenticationError();
    }
  };

  return (
    <InfoModal
      isOpen={error !== null}
      onClose={handleClose}
      content={message}
      notificationType="error"
      notificationMessage={message}
    />
  );
};

const mapStateToProps = state => ({
  error: state.application.errors?.authentication
});

const mapDispatchToProps = dispatch => ({
  clearAuthenticationError: () =>
    dispatch({
      type: ActionTypes.APPLICATION_ERROR_CLEAR,
      payload: { type: 'authentication' }
    })
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LoginSnackbar);
